import type { RealtimeHandler } from "@/shared/realtime";

import { analysisQueryOptions } from "../api/analysisQueryOptions";
import type { Analysis } from "../model/Analysis";
import { isAnalysisFinished } from "../model/isAnalysisFinished";

// `analysis.progress` → шаг и статус в кэше разбора без запроса.
// Идемпотентен: повтор события даёт тот же кэш. Разбор, который уже закончился,
// не откатывается назад запоздалым событием. Разбора нет в кэше — экран его ещё
// не открывал, перечитает через REST сам.
export const handleAnalysisProgress: RealtimeHandler<"analysis.progress"> = (
  event,
  { queryClient },
) => {
  queryClient.setQueryData<Analysis>(analysisQueryOptions(event.analysis_id).queryKey, (old) => {
    if (old === undefined || isAnalysisFinished(old.status)) {
      return old;
    }
    return { ...old, status: event.status, step: event.step, next_retry_at: event.next_retry_at };
  });
};
